<template>
    <div class="mx-auto mt-5">
        <div id="header-identificacao" class="row bg-light mb-2">
            <div class="col-sm-12 col-md-6">
                <fieldset class="form-group">
                    <div role="group" class="bv-no-focus-ring">
                        <label for="devedor">Devedor:</label>
                        <input id="devedor" type="text" readonly="readonly" :value="nomeDevedorFormatado()"
                               class="font-weight-bold form-control-plaintext">
                    </div>
                </fieldset>
            </div>
            <div class="col-sm-12 col-md-6">
                <fieldset class="form-group">
                    <div role="group" class="bv-no-focus-ring">
                        <label>Tipo de TRP selecionado:</label>
                        <input type="text" readonly="readonly" :value="trp.tipoTrp.descricao" v-if="trp.tipoTrp"
                               class="font-weight-bold form-control-plaintext">
                    </div>
                </fieldset>
            </div>
        </div>

        <hr class="mt-4"/>

        <p><b>O TRP abrangerá as seguintes CDA's:</b></p>
        <p>{{listarCdasSelecionadas()}}</p>
        <p><b>Ao confirmar a emissão do TRP {{this.trp && this.trp.tipoTrp ? this.trp.tipoTrp.descricao : ''}} para as CDA's acima listadas, o usuário CERTIFICA:</b></p>
        <ul>
            <li v-if="this.trp && this.trp.tipoTrp && this.trp.tipoTrp.indExigeRequisicao">{{this.trp.tipoTrp.descricaoExigeRequisicao}}</li>
            <li v-if="this.trp && this.trp.tipoTrp && this.trp.tipoTrp.indExigeDesistencia">{{this.trp.tipoTrp.descricaoExigeDesistencia}}</li>
            <li v-if="this.trp && this.trp.tipoTrp && this.trp.tipoTrp.indExigePagamentoCustas">{{this.trp.tipoTrp.descricaoExigePagamentoCustas}}</li>
            <li v-if="this.trp && this.trp.tipoTrp && this.trp.tipoTrp.indExigeGarantia && possuiValorGarantia()">{{this.trp.tipoTrp.descricaoExigeGarantia}}</li>
        </ul>

        <CompLoading ref="loading"/>
    </div>
</template>

<script>
    import formatarMixins from '../../../mixins/formatarMixins';
    import CompLoading from "../../shared/components/CompLoading";

    export default {
        props: ['devedor','trp','cdasSelecionadas'],
        mixins: [ formatarMixins ],
        components: {CompLoading},
        data() {
            return {
                urlApi: null,
                token: null
            }
        },
        computed: {
            getTheme() {
                return this.$store.getters.getTheme
            }
        },
        methods: {
            listarCdasSelecionadas() {
                let cdas = '';

                for(let i = 0; i < this.cdasSelecionadas.length; i++) {
                    if(cdas != '') {
                        cdas += ', ';
                    }
                    cdas += this.cdasSelecionadas[i].numeroDivida;
                }

                return cdas;
            },
            nomeDevedorFormatado() {
                return this.trp.devedor.nome +
                    (this.trp.devedor.documento != null && this.trp.devedor.documento.length == 10 ? ' (CNPJ Raiz ' :
                        this.trp.devedor.documento != null && this.trp.devedor.documento.length <= 14 ? ' (CPF ' : ' (CNPJ ') +
                    this.trp.devedor.documento + ')';
            },
            possuiValorGarantia() {
                let valorTotal = 0;
                for(let i = 0; i < this.cdasSelecionadas.length; i++) {
                    valorTotal += this.cdasSelecionadas[i].valor;
                }
                return valorTotal >= this.trp.tipoTrp.valorGarantia;
            },
        },
        mounted() {
            this.$store.commit("setMessages", {});
            this.urlApi = process.env.VUE_APP_ROOT_API;
            this.token = JSON.parse(this.$store.getters.getUser).access_token;
        }
    }
</script>

<style scoped>
    .memoria {
        list-style: none;
    }

    .mem-descricao {
        text-align: right;
    }

    .campo-email {
        margin: -.5rem 0;
    }

    .mem-total {
        text-align: right;
        font-weight: 700;
    }
</style>